import { http } from "./httpServices";
import { SETTINGS } from "./constants";

export function getSettings(type: string) {
  return http.get(`${SETTINGS}?type=${type}`);
}

export function getSettingsEntryAccess() {
  return http.get(`${SETTINGS}/entry-access`);
}

export function putEntryAccessUpdate(
  entryAccessType: "parking" | "topup" | "disputenotify" | "reservationfee" | "membershipfee",
  data: {
    name: string;
    [any: string]: any;
    isActive: boolean;
  }
) {
  return http.put(`${SETTINGS}?type=${entryAccessType}`, data);
}

export function getTransactionOptions() {
  return http.get(`${SETTINGS}?type=cms`);
}
